import { render, staticRenderFns } from "./money_check_dollar.vue?vue&type=template&id=639da15e"
import script from "./money_check_dollar.vue?vue&type=script&lang=js"
export * from "./money_check_dollar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports